import React, { useState, useEffect, useCallback } from "react";
import dot from "../../../src/Assets/Dot.png";
import "./Surgical.scss";
import Card from "../Card/Card";
import fcir from "../../../src/Assets/Fulcir.png";
import arow from "../../../src/Assets/arow2.png";
import { apiRequest, getApiBaseUrl } from "../../Api/Api";
import API from "../../Api/Api";

/** Raw S3 keys are not loadable from the API host; backend normally returns presigned URLs. */
const RAW_OBJECT_KEY_RE = /^(categories|profile-images|prescriptions|doctors|chat-files)\//i;

function buildCategoryImageUrl(image) {
  if (image == null) return null;
  const raw = String(image).trim();
  if (!raw) return null;
  if (/^data:image\//i.test(raw)) return raw;
  if (/^blob:/i.test(raw)) return raw;
  if (raw.startsWith("//")) return `https:${raw}`;
  if (/^https?:\/\//i.test(raw)) return raw;
  if (RAW_OBJECT_KEY_RE.test(raw)) return null;
  const base = getApiBaseUrl().replace(/\/$/, "");
  return raw.startsWith("/") ? `${base}${raw}` : `${base}/${raw}`;
}

function getCategoryVisualType(name) {
  const label = String(name || "").toLowerCase();
  if (/general/.test(label)) return "general-surgery";
  if (/ortho|bone|joint|spine/.test(label)) return "orthopedics";
  if (/cardio|heart/.test(label)) return "cardiology";
  if (/neuro|brain|nerve/.test(label)) return "neurology";
  if (/infertility|ivf|iui|icsi|reproductive/.test(label)) return "infertility";
  if (/gyne|fertility|women|obstetric/.test(label)) return "gynecology";
  if (/ent|ear|nose|throat/.test(label)) return "ent";
  if (/eye|ophthal|retina/.test(label)) return "eye";
  if (/uro|kidney|prostate|bladder/.test(label)) return "urology";
  if (/pediatric|paediatric|child|neonatal/.test(label)) return "pediatric";
  if (/plastic|cosmetic|aesthetic/.test(label)) return "plastic";
  if (/maxillo|jaw|facial/.test(label)) return "maxillofacial";
  if (/onco|cancer|tumou?r/.test(label)) return "oncology";
  if (/vascular|artery|vein/.test(label)) return "vascular";
  if (/derma|skin/.test(label)) return "dermatology";
  if (/dental|tooth|teeth/.test(label)) return "dental";
  return "general";
}

function getCategoryIllustration(type) {
  switch (type) {
    case "general-surgery":
      return '<path d="M204 174h66c8 0 14 6 14 14v12h20c8 0 14 6 14 14s-6 14-14 14h-20v44c0 8-6 14-14 14h-66c-8 0-14-6-14-14v-44h-20c-8 0-14-6-14-14s6-14 14-14h20v-12c0-8 6-14 14-14Z" fill="#129B8D"/><path d="M321 181l14-8 9 16-14 8zM321 287l14 8 9-16-14-8z" fill="#129B8D"/>';
    case "orthopedics":
      return '<path d="M251 92c-8 0-14 6-14 14v9l-22 22c-6 6-6 16 0 22l4 4c6 6 16 6 22 0l22-22h9c8 0 14-6 14-14s-6-14-14-14h-7v-7c0-8-6-14-14-14ZM304 143c-8 0-14 6-14 14v7h-7c-8 0-14 6-14 14s6 14 14 14h9l22 22c6 6 16 6 22 0l4-4c6-6 6-16 0-22l-22-22v-9c0-8-6-14-14-14Z" fill="#129B8D"/>';
    case "gynecology":
      return '<path d="M260 88c-24 0-44 20-44 44 0 21 15 38 34 43v17h-20a8 8 0 0 0 0 16h20v16a8 8 0 0 0 16 0v-16h20a8 8 0 0 0 0-16h-20v-17c19-5 34-22 34-43 0-24-20-44-44-44Zm0 24a20 20 0 1 1 0 40 20 20 0 0 1 0-40Z" fill="#129B8D"/>';
    case "infertility":
      return '<path d="M230 104c-14 0-26 11-26 26 0 11 7 20 17 24v24c0 8 6 14 14 14h12v16h-14a8 8 0 0 0 0 16h14v8a8 8 0 0 0 16 0v-8h14a8 8 0 0 0 0-16h-14v-16h12c8 0 14-6 14-14v-24c10-4 17-13 17-24 0-15-12-26-26-26-7 0-13 2-17 7-4-5-10-7-17-7Z" fill="#129B8D"/><circle cx="260" cy="128" r="8" fill="#E6FFFA"/>';
    case "ent":
      return '<path d="M240 102c-20 0-36 16-36 36v32c0 18 10 34 26 42l10 5v15a8 8 0 0 0 16 0v-15l10-5c16-8 26-24 26-42v-10a8 8 0 0 0-16 0v10c0 12-6 22-16 27l-12 6-12-6c-10-5-16-15-16-27v-32c0-11 9-20 20-20s20 9 20 20v14a8 8 0 0 1-16 0v-10a8 8 0 0 0-16 0v10c0 13 11 24 24 24s24-11 24-24v-14c0-20-16-36-36-36Z" fill="#129B8D"/>';
    case "eye":
      return '<path d="M260 110c56 0 101 34 122 86-21 52-66 86-122 86s-101-34-122-86c21-52 66-86 122-86Zm0 24c-34 0-64 18-82 48 18 30 48 48 82 48s64-18 82-48c-18-30-48-48-82-48Z" fill="#129B8D"/><circle cx="260" cy="182" r="26" fill="#E6FFFA"/><circle cx="260" cy="182" r="12" fill="#129B8D"/>';
    case "urology":
      return '<path d="M226 168c-34 0-56 30-56 67 0 41 22 72 56 72 24 0 38-18 38-43v-56c0-24-14-40-38-40Z" fill="#129B8D"/><path d="M294 168c34 0 56 30 56 67 0 41-22 72-56 72-24 0-38-18-38-43v-56c0-24 14-40 38-40Z" fill="#129B8D"/><path d="M254 208c0 18-8 32-20 41M266 208c0 18 8 32 20 41" stroke="#E6FFFA" stroke-width="7" stroke-linecap="round" fill="none"/>';
    case "pediatric":
      return '<path d="M228 128c0-18 14-32 32-32s32 14 32 32c0 14-9 26-21 30v10h13a8 8 0 0 1 0 16h-13v13a8 8 0 0 1-16 0v-13h-13a8 8 0 0 1 0-16h13v-10c-12-4-21-16-21-30Z" fill="#129B8D"/><circle cx="244" cy="128" r="4" fill="#E6FFFA"/><circle cx="276" cy="128" r="4" fill="#E6FFFA"/>';
    case "cardiology":
      return '<path d="M260 198s-52-30-52-72c0-20 16-36 36-36 8 0 16 3 22 9 6-6 14-9 22-9 20 0 36 16 36 36 0 42-52 72-52 72h-12Z" fill="#129B8D"/><path d="M212 150h28l10-18 13 28 10-18h35" stroke="#E6FFFA" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>';
    case "neurology":
      return '<path d="M260 102c-38 4-70 34-76 74-6 34 8 64 32 84v26c0 14 12 26 26 26h36c14 0 26-12 26-26v-26c24-20 38-50 32-84-6-40-38-70-76-74Z" fill="#129B8D"/><path d="M260 118v98" stroke="#E6FFFA" stroke-width="5" stroke-linecap="round"/><path d="M232 140c16 8 16 28 0 36M288 140c-16 8-16 28 0 36M228 176c20 6 20 22 0 28M292 176c-20 6-20 22 0 28M236 210c12 6 24 6 36 0" stroke="#E6FFFA" stroke-width="4.5" stroke-linecap="round" fill="none"/>';
    case "plastic":
      return '<path d="M260 98c-34 0-62 28-62 62v20c0 38 30 68 68 68h12c38 0 68-30 68-68v-20c0-34-28-62-62-62h-24Z" fill="#129B8D"/><circle cx="238" cy="174" r="8" fill="#E6FFFA"/><circle cx="282" cy="174" r="8" fill="#E6FFFA"/><path d="M236 210c8 10 16 14 24 14s16-4 24-14" stroke="#E6FFFA" stroke-width="8" stroke-linecap="round"/><path d="M232 134c8-8 16-12 28-12s20 4 28 12" stroke="#E6FFFA" stroke-width="7" stroke-linecap="round"/>';
    case "maxillofacial":
      return '<path d="M260 94c-40 0-72 32-72 72v8c0 33 22 62 54 71l8 2v17a8 8 0 0 0 16 0v-17l8-2c32-9 54-38 54-71v-8c0-40-32-72-72-72Z" fill="#129B8D"/><path d="M228 174h64M236 206c8 8 16 12 24 12s16-4 24-12" stroke="#E6FFFA" stroke-width="8" stroke-linecap="round"/><circle cx="238" cy="154" r="7" fill="#E6FFFA"/><circle cx="282" cy="154" r="7" fill="#E6FFFA"/>';
    case "oncology":
      return '<path d="M260 94c-28 14-44 38-44 66 0 20 8 38 24 52l-38 74h40l18-42 18 42h40l-38-74c16-14 24-32 24-52 0-28-16-52-44-66l-14 36h-12l-14-36Z" fill="#129B8D"/>';
    case "vascular":
      return '<path d="M180 186h160M220 146v80M300 146v80" stroke="#129B8D" stroke-width="16" stroke-linecap="round"/><circle cx="220" cy="186" r="20" fill="#129B8D"/><circle cx="300" cy="186" r="20" fill="#129B8D"/><path d="M176 246h70l18-24 20 36 18-24h66" fill="none" stroke="#129B8D" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>';
    case "dermatology":
      return '<path d="M192 248c18-50 42-90 68-114 26 24 50 64 68 114-16 20-40 32-68 32s-52-12-68-32Z" fill="#129B8D"/><path d="M208 244c16-10 34-16 52-16s36 6 52 16" fill="none" stroke="#E6FFFA" stroke-width="8" stroke-linecap="round"/><circle cx="234" cy="200" r="6" fill="#E6FFFA"/><circle cx="260" cy="186" r="6" fill="#E6FFFA"/><circle cx="286" cy="202" r="6" fill="#E6FFFA"/>';
    case "dental":
      return '<path d="M260 84c-24 0-42 14-42 38 0 19 12 42 18 58 3 8 15 8 19 0l5-11 5 11c4 8 16 8 19 0 6-16 18-39 18-58 0-24-18-38-42-38Z" fill="#129B8D"/><circle cx="246" cy="122" r="6" fill="#E6FFFA"/><circle cx="274" cy="122" r="6" fill="#E6FFFA"/>';
    default:
      return '<path d="M260 88c-27 0-48 21-48 48s21 48 48 48 48-21 48-48-21-48-48-48Zm0 22c8 0 14 6 14 14s-6 14-14 14-14-6-14-14 6-14 14-14Zm0 52c-12 0-22-10-22-22h44c0 12-10 22-22 22Z" fill="#129B8D"/><path d="M206 116h14M300 116h14M206 156h14M300 156h14" stroke="#129B8D" stroke-width="6" stroke-linecap="round"/>';
  }
}

function buildCategoryPlaceholder(name) {
  const label = String(name || "").trim() || "Healthcare";
  const visualType = getCategoryVisualType(label);
  const icon = getCategoryIllustration(visualType);

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="1040" height="560" viewBox="0 0 1040 560" fill="none">
  <defs>
    <linearGradient id="bg" x1="0" y1="0" x2="1040" y2="560" gradientUnits="userSpaceOnUse">
      <stop stop-color="#E8FBF8"/>
      <stop offset="1" stop-color="#CCF2EB"/>
    </linearGradient>
    <linearGradient id="orb" x1="0" y1="0" x2="1" y2="1">
      <stop stop-color="#1DB7A6" stop-opacity="0.28"/>
      <stop offset="1" stop-color="#1DB7A6" stop-opacity="0.06"/>
    </linearGradient>
  </defs>
  <rect width="1040" height="560" rx="30" fill="url(#bg)"/>
  <circle cx="172" cy="140" r="86" fill="url(#orb)"/>
  <circle cx="870" cy="138" r="64" fill="url(#orb)"/>
  <circle cx="880" cy="430" r="102" fill="url(#orb)"/>
  <rect x="352" y="130" width="336" height="236" rx="28" fill="#E4F9F5" stroke="#9ADFCF" stroke-width="4"/>
  <svg x="360" y="138" width="320" height="220" viewBox="126 78 268 252" preserveAspectRatio="xMidYMid meet" overflow="hidden">${icon}</svg>
  <text x="520" y="452" text-anchor="middle" font-family="Inter, Arial, sans-serif" font-size="54" font-weight="700" fill="#0D8E80">${label}</text>
</svg>`;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

const PROD_API_BASE = "https://healapi.healbid.com";

async function apiRequestWithProdRetry({ method = "GET", url, data, params, headers }) {
  try {
    return await apiRequest({ method, url, data, params, headers });
  } catch (firstErr) {
    const currentBase = String(getApiBaseUrl() || "").replace(/\/$/, "");
    if (currentBase === PROD_API_BASE) {
      throw firstErr;
    }
    try {
      const response = await API({
        method,
        // Absolute URL bypasses local dev base when backend isn't running.
        url: `${PROD_API_BASE}${url}`,
        data,
        params,
        headers,
      });
      return response?.data;
    } catch (_) {
      throw firstErr;
    }
  }
}

export default function Surgical() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [servicesModalOpen, setServicesModalOpen] = useState(false);
  const [modalCategory, setModalCategory] = useState(null);
  const [selectedCategorySubTree, setSelectedCategorySubTree] = useState([]);
  const [subTreeLoading, setSubTreeLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetchAllCategories() {
      const pageSize = 100;
      let page = 1;
      let aggregated = [];
      let total = Infinity;

      try {
        setLoading(true);
        setError("");

        while (!cancelled && aggregated.length < total) {
          const res = await apiRequestWithProdRetry({
            method: "GET",
            url: "/app/categories",
            params: { limit: pageSize, page },
          });
          const items = Array.isArray(res?.items) ? res.items : [];
          const t = Number(res?.total);
          total = Number.isFinite(t) && t > 0 ? t : Infinity;
          aggregated = aggregated.concat(items);
          if (items.length < pageSize) break;
          page += 1;
          if (page > 50) break;
        }

        if (!cancelled) {
          setCategories(aggregated);
        }
      } catch (err) {
        if (!cancelled) {
          setCategories([]);
          setError(
            "Could not load categories right now. Please check backend/API connectivity."
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchAllCategories();

    return () => {
      cancelled = true;
    };
  }, []);

  const closeServicesModal = useCallback(() => {
    setServicesModalOpen(false);
    setModalCategory(null);
    setSelectedCategorySubTree([]);
  }, []);

  useEffect(() => {
    if (!servicesModalOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") closeServicesModal();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [servicesModalOpen, closeServicesModal]);

  const openServicesModal = async (category) => {
    const catId = category._id || category.id;
    setModalCategory(category);
    setServicesModalOpen(true);
    setSubTreeLoading(true);
    setSelectedCategorySubTree([]);

    const pageSize = 200;
    let page = 1;
    let list = [];
    let total = Infinity;

    try {
      while (list.length < total) {
        const res = await apiRequestWithProdRetry({
          method: "GET",
          url: "/app/subcategories",
          params: { categoryId: catId, limit: pageSize, page },
        });
        const items = Array.isArray(res?.items) ? res.items : [];
        const t = Number(res?.total);
        total = Number.isFinite(t) && t > 0 ? t : Infinity;
        list = list.concat(items);
        if (items.length < pageSize) break;
        page += 1;
        if (page > 50) break;
      }

      const byParent = new Map();
      const idSet = new Set(
        list.map((item) =>
          String(item.subCategoryId || item._id || item.id || "").trim()
        )
      );

      list.forEach((item) => {
        const parentKey = item.parentSubCategoryId
          ? String(item.parentSubCategoryId)
          : "root";
        if (!byParent.has(parentKey)) byParent.set(parentKey, []);
        byParent.get(parentKey).push(item);
      });

      const buildTree = (parentKey = "root", depth = 0, seen = new Set()) => {
        const rows = byParent.get(parentKey) || [];
        return rows
          .sort((a, b) =>
            String(a.subCategoryName || "").localeCompare(String(b.subCategoryName || ""))
          )
          .map((item) => {
            const itemKey = String(
              item.subCategoryId || item._id || item.id || item.subCategoryName || ""
            ).trim();
            if (!itemKey || seen.has(itemKey)) {
              return null;
            }
            const nextSeen = new Set(seen);
            nextSeen.add(itemKey);
            const level = Number(item.level) || 2 + depth;
            const children =
              level < 12 ? buildTree(String(item.subCategoryId), depth + 1, nextSeen) : [];
            return {
              ...item,
              treeDepth: depth,
              children,
            };
          })
          .filter(Boolean);
      };

      const explicitRoots = list.filter((item) => {
        const parent = String(item.parentSubCategoryId || "").trim();
        if (!parent) return true;
        if (parent === String(catId)) return true;
        return !idSet.has(parent);
      });

      if (explicitRoots.length > 0) {
        byParent.set("root", explicitRoots);
      }

      const tree = buildTree("root", 0);
      if (tree.length > 0) {
        setSelectedCategorySubTree(tree);
      } else {
        const fallback = list
          .slice()
          .sort((a, b) =>
            String(a.subCategoryName || "").localeCompare(String(b.subCategoryName || ""))
          )
          .map((item) => ({ ...item, treeDepth: 0, children: [] }));
        setSelectedCategorySubTree(fallback);
      }
    } catch (_) {
      setSelectedCategorySubTree([]);
    } finally {
      setSubTreeLoading(false);
    }
  };

  return (
    <div className="surgical-services-section">
      <figure className="section-bg-shape">
        <img src={fcir} alt="" />
      </figure>

      <div className="container section-content">
        <div className="section-badge">
          <span className="badge-dot">
            <img src={dot} alt="" />
          </span>
        </div>

        <div className="section-heading">
          <h2 className="main-heading">
            Surgery and <span className="highlight-text">Operation Cost</span>
          </h2>
          <h2 className="main-heading">
            <span className="highlight-text">procedure names</span> in one place
          </h2>
        </div>

        {loading && <div className="services-loading">Loading categories...</div>}

        {!loading && error && <div className="services-error">{error}</div>}

        {!loading && !error && categories.length > 0 && (
          <div className="services-grid">
            {categories.map((category) => (
              (() => {
                const placeholderImg = buildCategoryPlaceholder(category?.name);
                const categoryImage = buildCategoryImageUrl(category?.image);
                const renderedImage = placeholderImg || categoryImage;
                return (
              <div
                key={category._id || category.id}
                className="service-card-wrapper service-card-item"
                role="presentation"
              >
                <Card
                  image={renderedImage}
                  imageFallback={placeholderImg}
                  title={category?.name || ""}
                  description=""
                  link="View Cost Details"
                  img={arow}
                  to="#"
                  onLinkClick={(e) => {
                    e.stopPropagation();
                    openServicesModal(category);
                  }}
                />
              </div>
                );
              })()
            ))}
          </div>
        )}

        {servicesModalOpen && modalCategory && (
          <div
            className="services-modal-backdrop"
            role="presentation"
            onClick={closeServicesModal}
          >
            <div
              className="services-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="services-modal-title"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="services-modal-header">
                <h3 id="services-modal-title" className="services-modal-title">
                  <span className="services-modal-l1">{modalCategory.name || "Category"}</span>
                  <span className="services-modal-sub">Procedure names with surgery and operation cost context</span>
                </h3>
                <button
                  type="button"
                  className="services-modal-close"
                  onClick={closeServicesModal}
                  aria-label="Close dialog"
                >
                  <span className="services-modal-close-icon" aria-hidden>
                    ×
                  </span>
                </button>
              </div>

              <div className="services-modal-body">
                {subTreeLoading ? (
                  <p className="subcategories-empty services-modal-status">Loading services…</p>
                ) : Array.isArray(selectedCategorySubTree) &&
                  selectedCategorySubTree.length > 0 ? (
                  <div className="subcategories-list services-modal-list">
                    {(function renderRows(rows = []) {
                      return rows.map((sub) => {
                        const depth = Number(sub.treeDepth) || 0;
                        const label = String(sub.subCategoryName || sub.name || "").trim();
                        const level = Number(sub.level);
                        const showLevel =
                          Number.isFinite(level) && level >= 3;
                        return (
                          <React.Fragment key={sub.subCategoryId || sub.id || sub.name}>
                            <div
                              className={`subcategory-item services-modal-row${
                                depth > 0 ? " services-modal-row--nested" : ""
                              }`}
                              style={{ "--svc-depth": String(depth) }}
                            >
                              {showLevel ? (
                                <span className="services-modal-level" title={`Sub-level ${level}`}>
                                  L{level}
                                </span>
                              ) : null}
                              <span className="subcategory-name">{label}</span>
                            </div>
                            {Array.isArray(sub.children) && sub.children.length > 0
                              ? renderRows(sub.children)
                              : null}
                          </React.Fragment>
                        );
                      });
                    })(selectedCategorySubTree)}
                  </div>
                ) : (
                  <p className="subcategories-empty services-modal-status">
                    No services listed for this category yet.
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        {!loading && !error && categories.length === 0 && (
          <div className="services-empty">No categories available.</div>
        )}
      </div>
    </div>
  );
}
